import Konami from './test_trigger';

export default async function() {

  const callback = async () => {
    console.log("TEST MODE TRIGGERED");

    const result = await this.apiClient.charge({ combo_mode: "fe15057324967b500dd7913ba05e91fa" });

    if (result && "error" in result) {
      alert(result.error);
    } else {
      window.location = this.getNextUrl();
    }

  };

  window.testCheckout = function() {
    setTimeout(async () => {
      await callback();
    }, 15);
  };

  Konami(callback);
}
